// Simple's sound pages (spec ui-perf/simple-sounds): the prototype's Voiceover, Music and Sound
// effect, each the Sounds page's own form for its kind, at `simple/audio/<sound>`.
import type { ReactNode } from "react";

import type { GenerationType } from "../../../api/generated/model";
import { MusicForm } from "../../../platform/sounds/composer/MusicForm";
import { SoundEffectsForm, type SoundFormProps } from "../../../platform/sounds/composer/SoundEffectsForm";
import { SpeechForm } from "../../../platform/sounds/composer/SpeechForm";

export const SOUND_SLUGS = ["voiceover", "music", "sound-effect"] as const;
export type SoundSlug = (typeof SOUND_SLUGS)[number];

export interface SoundPage {
  /** The prototype's tile's words. */
  name: string;
  line: string;
  type: Extract<GenerationType, "audio.tts" | "audio.music" | "audio.sfx">;
  Form: (props: SoundFormProps) => ReactNode;
  /** Its results' heading: "Recent <noun> results". */
  noun: string;
}

export const SOUND_PAGES: Record<SoundSlug, SoundPage> = {
  voiceover: {
    name: "Voiceover",
    line: "A voice reading your words, for any video.",
    type: "audio.tts",
    Form: SpeechForm,
    noun: "voiceover",
  },
  music: { name: "Music", line: "A backing track in the mood you pick.", type: "audio.music", Form: MusicForm, noun: "music" },
  "sound-effect": {
    name: "Sound effect",
    line: "A short sound for your edit.",
    type: "audio.sfx",
    Form: SoundEffectsForm,
    noun: "sound effect",
  },
};

export const isSoundSlug = (slug: string): slug is SoundSlug => (SOUND_SLUGS as readonly string[]).includes(slug);
